// extracted by mini-css-extract-plugin
var _1 = "CalendarGridDayPopover-modulecompact__F3gwp";
var _2 = "CalendarGridDayPopover-modulerows__Dcjmq";
export { _1 as "compact", _2 as "rows" }
